import { Component, Inject } from '@angular/core';
import { CalibrationBalanceEssayAsLeft, CalibrationBalanceEssayAsLeftValue } from '../../../../model/calibrationBalance';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { ArrayUtils } from 'src/app/utils/arrayUtils';
import { NumberUtils } from '../../../../utils/numberUtils';
import { BalanceEssayTypeEnum } from 'src/app/model/balanceEssayType';

export interface DialogDataCalibrationBalanceAsLeft {
  item: CalibrationBalanceEssayAsLeft;
  minValues: number;
  idEssayType: number;
}
@Component({
  selector: 'app-calibration-balance-edit-as-left-dialog',
  templateUrl: './calibration-balance-edit-as-left-dialog.component.html',
  styleUrl: './calibration-balance-edit-as-left-dialog.component.scss',
  standalone: false
})
export class CalibrationBalanceEditAsLeftDialogComponent {
  minValues: number;
  notAllowed = [
    BalanceEssayTypeEnum.ESSAY_ECCENTRICITY, BalanceEssayTypeEnum.ESSAY_FUNDAMENTAL
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogDataCalibrationBalanceAsLeft,
    public dialogRef: MatDialogRef<CalibrationBalanceEditAsLeftDialogComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService) { }

  ngOnInit(): void {
    this.minValues = Math.max(this.data.minValues, 1);

    if (ArrayUtils.isEmpty(this.data.item.values)) {
      this.data.item.values = [];

      if (this.data.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY && this.data.minValues === 0) {
        for (let i = 0; i <= 6; i++) {
          this.newValue();
        }
      }
    }
  
    if (!this.notAllowed.includes(this.data.idEssayType)) {
      const diff = this.minValues - this.data.item.values.length;

      for (let i = 0; i < diff; i++) {
        this.newValue();
      }
    } else {
       if (!this.data.item.values || this.data.item.values?.length === 0) {
          this.newValue();
       }
    }
  }

  newValue(): void {
    this.data.item.values.push(new CalibrationBalanceEssayAsLeftValue());
  }

  removeValue(index: number): void {
    this.data.item.values.splice(index, 1);
  }

  public setValue(index: number, value: number | string): void {
    if (value == null || value === '') {
      this.data.item.values[index].value = null;
    } else {
      this.data.item.values[index].value = +value;
    }
  }

  onOkClick(): void {

    const errs = [];

    if (this.data.item.pattern == null || isNaN(+this.data.item.pattern)) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.pattern.error'));
    }
    if (ArrayUtils.isEmpty(this.data.item.values)) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.values.error'));
    } else if (this.data.idEssayType === BalanceEssayTypeEnum.ESSAY_REPEATABILTY && this.data.item.values.length < 2) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.repeat.values.error'));
    } else {
      if (this.data.item.values.filter(v => v == null || v.value == null).length !== 0) {
        errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.values.value.error'));
      } else {
        if (this.data.item.pattern || !isNaN(+this.data.item.pattern)) {
          if (!this.notAllowed.includes(this.data.idEssayType)) {
            const resultCount = this.data.item.values.filter(v => NumberUtils.countDecimalsAny(v.value) >  NumberUtils.countDecimalsAny(this.data.item.pattern));
            if (resultCount && resultCount.length > 0) {
              errs.push(this.translate.instant('calibrateEquipmentEdit.asLeft.dialog.lengthPattern.error'));
            }
          }
          
        }
      }
    
    }

    if (errs.length === 0) {
      this.dialogRef.close(this.data.item);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

onHide(): boolean {
  
  return !this.notAllowed.includes(this.data.idEssayType);
}
}
